import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";

import ProxySubSubTab from "./Proxies/Proxys";
import WebshareCredentialsSubSubTab from "./Proxies/WebshareCredentials";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`proxy-tabpanel-${index}`}
    aria-labelledby={`proxy-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const ProxySubTab = () => {
  const [proxySubTab, setProxySubTab] = useState(1);

  const handleProxySubTabChange = (event, newValue) => {
    setProxySubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={proxySubTab}
              onChange={handleProxySubTabChange}
              aria-label="proxy tabs"
            >
              <Tab label="Webshare Credentials" />
              <Tab label="Proxy Management" />
            </Tabs>
          </Box>

          {/* Webshare Credentials Tab */}
          <TabPanel value={proxySubTab} index={0}>
            <WebshareCredentialsSubSubTab />
          </TabPanel>

          {/* Proxy Management Tab */}
          <TabPanel value={proxySubTab} index={1}>
            <ProxySubSubTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProxySubTab;
